/**
 * @generated SignedSource<<ac5f66eb5475392efbafba0f851f4f07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CategorizeStakeholderInputObject = {
  allocations: ReadonlyArray<CategorizationAllocationInputObject>;
  perspectiveId: string;
  stakeholderId: string;
};
export type CategorizationAllocationInputObject = {
  amountCents?: number | null | undefined;
  categoryId: string;
  ordinal?: number | null | undefined;
  sliceType?: string | null | undefined;
  weight?: number | null | undefined;
};
export type walletLedgerCells_CategorizeMutation$variables = {
  input: CategorizeStakeholderInputObject;
};
export type walletLedgerCells_CategorizeMutation$data = {
  readonly categorizeStakeholder: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type walletLedgerCells_CategorizeMutation = {
  response: walletLedgerCells_CategorizeMutation$data;
  variables: walletLedgerCells_CategorizeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletLedgerCells_CategorizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletLedgerCells_CategorizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "abd8cf84fa3aeb246b738062fecd4905",
    "id": null,
    "metadata": {},
    "name": "walletLedgerCells_CategorizeMutation",
    "operationKind": "mutation",
    "text": "mutation walletLedgerCells_CategorizeMutation(\n  $input: CategorizeStakeholderInputObject!\n) {\n  categorizeStakeholder(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "684483b5a5ba7fc4643a1192b563b132";

export default node;
